import React from 'react';

export default function PeliculaCard({pelicula}){
    

    return(
         <div className="card">
            <img className="card--image"
                 src={`https://image.tmdb.org/t/p/w185_and_h278_bestv2/${pelicula.poster_path}`} alt={pelicula.title + ' poster '}/>
            <div className="card--content">
                <h3 className="card--title">{pelicula.title}</h3>
                <p><small>FECHA DE ESTRENO: {pelicula.release_date}</small></p>
                <p><small>RATING: {pelicula.vote_average}</small></p>
                <p className="card--desc">{pelicula.overview}</p>
            </div>   
         </div>
            
    )
}